/**
 * @flow
 * @relayHash c155488997643cde9957d5467469a5d2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PortfolioOrderRequestList_viewer$ref = any;
export type PortfolioOrderRequestListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  accountType?: ?string,
|};
export type PortfolioOrderRequestListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PortfolioOrderRequestList_viewer$ref
  |}
|};
export type PortfolioOrderRequestListQuery = {|
  variables: PortfolioOrderRequestListQueryVariables,
  response: PortfolioOrderRequestListQueryResponse,
|};
*/


/*
query PortfolioOrderRequestListQuery(
  $first: Int
  $offset: Int
  $accountType: String
) {
  viewer {
    ...PortfolioOrderRequestList_viewer_33DeJ9
    id
  }
}

fragment PortfolioOrderRequestList_viewer_33DeJ9 on Query {
  portfolioOrderRequests(first: $first, offset: $offset, accountType: $accountType, orderBy: "-createdAt") {
    count
    edges {
      node {
        id
        status
        createdAt
        createdBy {
          id
          fullName
        }
        approvals {
          count
          edges {
            node {
              id
            }
          }
        }
        portfolioOrder {
          id
          account {
            id
            name
            clientaccount {
              accountType
              id
            }
          }
          stockOrders {
            edges {
              node {
                id
                brokerOrder {
                  status
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "accountType",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "accountType",
  "variableName": "accountType"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PortfolioOrderRequestListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PortfolioOrderRequestList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PortfolioOrderRequestListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolioOrderRequests",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-createdAt"
              }
            ],
            "concreteType": "PortfolioOrderRequestNodeConnection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfolioOrderRequestNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioOrderRequestNode",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "createdBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "approvals",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ApprovalNodeConnection",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ApprovalNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ApprovalNode",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolioOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioOrderNode",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "account",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AccountNode",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "name",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "clientaccount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ClientAccountNode",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "accountType",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "stockOrders",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StockOrderNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "StockOrderNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StockOrderNode",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokerOrder",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerOrderNode",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v5/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PortfolioOrderRequestListQuery",
    "id": null,
    "text": "query PortfolioOrderRequestListQuery(\n  $first: Int\n  $offset: Int\n  $accountType: String\n) {\n  viewer {\n    ...PortfolioOrderRequestList_viewer_33DeJ9\n    id\n  }\n}\n\nfragment PortfolioOrderRequestList_viewer_33DeJ9 on Query {\n  portfolioOrderRequests(first: $first, offset: $offset, accountType: $accountType, orderBy: \"-createdAt\") {\n    count\n    edges {\n      node {\n        id\n        status\n        createdAt\n        createdBy {\n          id\n          fullName\n        }\n        approvals {\n          count\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        portfolioOrder {\n          id\n          account {\n            id\n            name\n            clientaccount {\n              accountType\n              id\n            }\n          }\n          stockOrders {\n            edges {\n              node {\n                id\n                brokerOrder {\n                  status\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '593e769acc50fb8fbfdd932c1bf6ccd6';
module.exports = node;
